import { render, staticRenderFns } from "./walkingSurface.vue?vue&type=template&id=cd5ea168&"
import script from "./walkingSurface.vue?vue&type=script&lang=js&"
export * from "./walkingSurface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports